export default __webpack_public_path__ + "static/media/portfolio.1a2b2167.png";